import TimelineItem from '@material-ui/lab/TimelineItem';
import { withStyles } from '@material-ui/styles';

export const StyledTimelineItem = withStyles({
  missingOppositeContent: {
    '&:before': {
      content: 'none',
    },
  },
})(TimelineItem);
